import * as fp from 'lodash/fp';

export class Reply {
    static fromAny(data: any) {
        return new Reply(
            data.id,
            data.createdBy,
            data.creationDate,
            data.createdByUserId,
            data.title,
            data.description,
            data.notificationType,
            data.read,
            data.databaseIdentifier,
            data.topic,
            data.userId);
    }

    static fromNews(data: any) {
        return new Reply(
            null,
            data.createdBy,
            undefined,
            data.createdByUserId,
            `A:${data.title}`,
            data.description,
            5,
            false,
            data.databaseIdentifier,
            data.id,
            data.createdByUserId
        );
    }

    constructor(
        public id: string | null,
        public createdBy: string,
        public creationDate: string | undefined,
        public createdByUserId: string,
        public title: string,
        public description: string,
        public notificationType: number,
        public read: boolean,
        public databaseIdentifier: string,
        public topic: string,
        public userId: string,
    ) { }

    static equals(a: any, b: any) {
        if (!a || !b) return false;
        return fp.isEqual(Reply.fromAny(a), Reply.fromAny(b));
    }
}